import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

import Textlink from '@xingternal/malt-textlink';

/**
 * `message` needs to have a placeholder called `{link}`
 */
const MessageWithLink = ({ message, linkMessage, href, onClick, ...rest }) => {
  const linkAction = onClick ? { onClick } : { href };
  return (
    <FormattedMessage
      {...message}
      {...rest}
      values={{
        link: (
          <Textlink {...linkAction}>
            <FormattedMessage {...linkMessage} />
          </Textlink>
        ),
      }}
    />
  );
};

MessageWithLink.propTypes = {
  message: PropTypes.object.isRequired,
  linkMessage: PropTypes.object.isRequired,
  href: PropTypes.string,
  onClick: PropTypes.func,
};

export default MessageWithLink;
